// Crans de rapprochement entre une idee Vision 360 et la ligne budgetaire,
// du plus strict au plus large
enum PerimetreIdee {
	ARTICLE = 'article',
	SOUS_FAMILLE = 'sousFamille',
	FAMILLE = 'famille',
	SECTION = 'section',
	TOUTES = 'toutes',
}

// Ordre d'elargissement : chaque cran inclut les idees des precedents
export const PERIMETRES_IDEE = [
	PerimetreIdee.ARTICLE,
	PerimetreIdee.SOUS_FAMILLE,
	PerimetreIdee.FAMILLE,
	PerimetreIdee.SECTION,
	PerimetreIdee.TOUTES,
];

export default PerimetreIdee;
